import { countLabel, PLURAL } from './plural';

/**
 * Точное совпадение width×height. Нет размера у креатива или экрана — пара допустима.
 */
export const isFrameCompatibleWithCreative = (creative, frame) => {
    if (!creative || !frame) return false;
    if (creative.width == null || creative.height == null || frame.width == null || frame.height == null) {
        return true;
    }
    return Number(creative.width) === Number(frame.width)
        && Number(creative.height) === Number(frame.height);
};

const framesByGid = (frames) => {
    if (frames instanceof Map) return frames;
    const map = new Map();
    for (const frame of Array.isArray(frames) ? frames : []) {
        if (frame?.gid != null && frame.gid !== '') map.set(String(frame.gid), frame);
    }
    return map;
};

const sizeLabel = (frame) => {
    if (frame.width == null || frame.height == null) return 'без размера';
    return `${Number(frame.width)}×${Number(frame.height)}`;
};

/**
 * Выбранные экраны, которым не подходит ни один выбранный креатив.
 * Пока креативов нет, список пуст: покрывать ещё нечем.
 *
 * @returns {{ size: string, count: number }[]}
 */
export const uncoveredScreensBySize = (frames, gids, creatives) => {
    const selectedCreatives = (Array.isArray(creatives) ? creatives : []).filter(Boolean);
    if (selectedCreatives.length === 0) return [];

    const byGid = framesByGid(frames);
    const counts = new Map();
    for (const gid of gids || []) {
        const frame = byGid.get(String(gid));
        if (!frame) continue;
        if (selectedCreatives.some(creative => isFrameCompatibleWithCreative(creative, frame))) continue;
        const size = sizeLabel(frame);
        counts.set(size, (counts.get(size) || 0) + 1);
    }

    return [...counts.entries()]
        .map(([size, count]) => ({ size, count }))
        .sort((a, b) => a.size.localeCompare(b.size, 'ru', { numeric: true }));
};

export const formatUncoveredScreensNotice = (groups) => {
    if (!groups?.length) return '';
    const total = groups.reduce((sum, group) => sum + group.count, 0);
    const sizes = groups
        .map(group => `${group.size} — ${countLabel(group.count, PLURAL.SCREEN)}`)
        .join(', ');
    return `${countLabel(total, PLURAL.SCREEN)} без креатива своего размера: ${sizes}. Они остаются в кампании и не закупаются, пока не добавите креатив этого размера.`;
};
